<template>
	<v-row no-gutters class="fill-height">
		<v-col class="mx-0">
		<v-container fluid class="pa-0" style="position: fixed;" :class="{'open-nav': $store.getters.getSidebar && $vuetify.breakpoint.mdAndUp}">

			<v-card class="rounded-lg pa-6 pb-2 elevation-0 transparent">
				<v-card-title class="pa-0">
					<v-row no-gutters>
						<v-col class="col-10 col-sm-6 col-lg-4 ma-auto ml-0">
							<div class="pl-0 font-weight-bold">Nuova Timbratura</div>
						</v-col>
                    </v-row>
                </v-card-title>
            </v-card>
		</v-container>
		<v-container fluid class="pa-6 body-page" :class="$vuetify.breakpoint.mdAndUp ? '' : 'px-2'" style="margin-top: 110px; height: 100%">
			<v-card :elevation="1" class="background" style="height: 100%">


                <div ref="map" class="attendances-map"></div>

                <div class="text-center">                    
                    <p><strong>Precisione:</strong> {{accuracyMessage}}</p>
                    <v-btn
                        color="primary"
                        large
                        class="mt-5"
                        :disabled="!enableSend"
                        @click="sendAttendance"
                    >INVIA TIMBRATURA</v-btn>
                </div>
            </v-card>
        </v-container>
        </v-col>

        <confirm-dialog
            v-model="confirmEnableLocation"
            mainTitle="Devi attivare GPS"
            secondTitle="Per poter effettuare una timbratura è necessario attivare la funzione GPS dalle impostazioni del tuo dispositivo."
            :atExit="() => $eventBusUtility.navigateTo('home')"
            @confirm="enableLocation"
        ></confirm-dialog>
    </v-row>
</template>

<script>
import { importLibrary, MAP_ID } from '@/services/GoogleMapsService'
import { GeolocationService, DeviceService, DialogService, PlatformService } from '@/services/native'

export default {
	name: 'attendances-create',
	data() {
		return {
			map: null,
			position: null,
			watcher: null,
			confirmEnableLocation: false,
			posOptions: {
				enableHighAccuracy: false,
				timeout: 30000,
				maximumAge: 30000
			},
			minAccuracy: 50,
			places: [],
			placeMarkers: []
		}
	},

	mounted() {
		importLibrary('maps').then(async ({ Map }) => {
			await importLibrary('marker')

			this.map = new Map(this.$refs.map, {
				zoom: 16,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				fullscreenControl: false,
				mapTypeControl: false,
				panControl: false,
				streetViewControl: false,
				mapId: MAP_ID
			})

			this.init()
			this.loadPlaces()
		})
	},

	computed: {
		enableSend() {
			if(this.position) {
				return this.position.coords.accuracy <= this.minAccuracy
			}

			return false
		},

		accuracyMessage() {
			return this.enableSend ? Math.floor(this.position.coords.accuracy).toString() + ' metri' : 'Troppo grande (oltre ' + this.minAccuracy + ' metri)'
		}
	},

	async beforeDestroy() {
		if (this.watcher) {
			await GeolocationService.clearWatch(this.watcher)
		}
	},

	methods: {
		async init() {
			if (this.$store.getters.isMobile) {
				try {
					const permissions = await GeolocationService.checkPermissions()

					if (permissions.location === 'prompt' || permissions.location === 'prompt-with-rationale') {
						const newPermissions = await GeolocationService.requestPermissions()
						if (newPermissions.location === 'granted') {
							this.getCurrentPosition()
						}
					} else if (permissions.location === 'denied') {
						const confirmed = await DialogService.confirm({
							title: 'Accesso negato alla posizione',
							message: 'VolontApp non ha accesso alla tua posizione ed è necessario per poter utilizzare questa funzione. Vuoi accedere alle impostazioni dell\'app per abilitare l\'accesso?',
							okButtonTitle: 'Si',
							cancelButtonTitle: 'No'
						})

						if (confirmed) {
							this.openAppSettings()
						}
					} else if (permissions.location === 'granted') {
						this.getCurrentPosition()
					}
				} catch (error) {
					this.getCurrentPosition()
				}
			} else {
				this.getCurrentPosition()
			}
		},

		async getCurrentPosition() {
			try {
				const position = await GeolocationService.getCurrentPosition({
					enableHighAccuracy: true,
					timeout: 30000,
					maximumAge: 30000
				})

				this.position = position

				let myLatlng = { lat: position.coords.latitude, lng: position.coords.longitude }

				// Create pin element for the marker
				const pin = new google.maps.marker.PinElement({
					background: '#e75e5a',
					borderColor: '#c94a47',
					glyphColor: 'white'
				})

				const markerPos = new google.maps.marker.AdvancedMarkerElement({
					position: myLatlng,
					map: this.map,
					title: 'La tua posizione',
					content: pin.element
				})

				let circle = new google.maps.Circle({
					center: myLatlng,
					radius: position.coords.accuracy,
					map: this.map,
					fillColor: '#e75e5a',
					fillOpacity: 0.3,
					strokeColor: '#e65253',
					strokeOpacity: 1,
					strokeWeight: 2
				})

				this.map.setCenter(myLatlng)

				this.watcher = await GeolocationService.watchPosition((pos) => {
					this.position = pos
					let newPos = { lat: pos.coords.latitude, lng: pos.coords.longitude }
					this.map.setCenter(newPos)
					markerPos.position = newPos
					circle.setCenter(newPos)
					circle.setRadius(pos.coords.accuracy)
				},
				() => {},
				{ timeout: 10000, enableHighAccuracy: true })
			} catch (e) {
				// Geolocation error
			}
		},

		async sendAttendance() {
			let device_code = ''
			if (PlatformService.isNative()) {
				try {
					device_code = await DeviceService.getId()
				} catch (error) {
					// console.error('Device ID error:', error)
				}
			}

			let data = {
				personal_device_code: device_code,
				latitude: this.position.coords.latitude.toFixed(8),
				longitude: this.position.coords.longitude.toFixed(8),
				precision: Math.floor(this.position.coords.accuracy),
				manual: false
			}

			this.axios.post('attendances', data).then(response => {
				if(response.data.status == 'success') {
					this.$eventBusUtility.navigateTo('attendances')
				} else {
					alert('error')
				}
			})
		},

		async openAppSettings() {
			if (PlatformService.isAndroid()) {
				// Open Android app settings
				if (typeof window.cordova !== 'undefined' && window.cordova.plugins && window.cordova.plugins.diagnostic) {
					window.cordova.plugins.diagnostic.switchToSettings()
				}
			} else if (PlatformService.isIOS()) {
				// Open iOS app settings
				if (typeof window.cordova !== 'undefined' && window.cordova.plugins && window.cordova.plugins.diagnostic) {
					window.cordova.plugins.diagnostic.switchToSettings()
				}
			}
		},

		enableLocation() {
			if (PlatformService.isAndroid()) {
				if (typeof window.cordova !== 'undefined' && window.cordova.plugins && window.cordova.plugins.diagnostic) {
					window.cordova.plugins.diagnostic.switchToLocationSettings()
				}
			}
		},

		async loadPlaces() {
			try {
				const response = await this.axios.get('places')
				if (response.data && response.data.data) {
					this.places = response.data.data
					this.addPlaceMarkers()
				}
			} catch (e) {
				// Error loading places
			}
		},

		addPlaceMarkers() {
			// Clear existing place markers
			this.placeMarkers.forEach(marker => {
				marker.map = null
			})
			this.placeMarkers = []

			// Create markers for each place
			this.places.forEach(place => {
				if (place.latitude && place.longitude) {
					const placeLatLng = {
						lat: parseFloat(place.latitude),
						lng: parseFloat(place.longitude)
					}

					// Create custom marker with VolontApp logo
					const logoImg = document.createElement('img')
					logoImg.src = '/img/volontapp-transparent.png'
					logoImg.style.width = '40px'
					logoImg.style.height = '40px'
					logoImg.style.opacity = '0.6'
					logoImg.style.borderRadius = '50%'
					logoImg.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)'

					const marker = new google.maps.marker.AdvancedMarkerElement({
						position: placeLatLng,
						map: this.map,
						title: place.name,
						content: logoImg
					})

					// Add circle to show the range if available
					if (place.range) {
						new google.maps.Circle({
							center: placeLatLng,
							radius: parseFloat(place.range),
							map: this.map,
							fillColor: '#4CAF50',
							fillOpacity: 0.15,
							strokeColor: '#4CAF50',
							strokeOpacity: 0.5,
							strokeWeight: 1
						})
					}

					this.placeMarkers.push(marker)
				}
			})
		}
	},
}
</script>

<style scoped>
.attendances-map {
    height: 50vh;
}
</style>